'use client';

import { PropsWithChildren, useContext, useEffect } from 'react';

import { FiltersState } from '../../types/filters';

import { FiltersContext } from './FiltersProvider';

type FiltersMediatorProps = PropsWithChildren<{ filtersState?: FiltersState }>;

export const FiltersMediator = ({
  children,
  filtersState,
}: FiltersMediatorProps) => {
  const [, , setMediatorState] = useContext(FiltersContext);

  useEffect(() => {
    const updateState = typeof setMediatorState === 'function' && filtersState;

    if (updateState) {
      setMediatorState(filtersState);
    }

    return () => {
      if (updateState) {
        setMediatorState(null);
      }
    };
  }, [filtersState, setMediatorState]);

  return children;
};
